import { Component, AfterViewInit, OnDestroy } from '@angular/core';

import { installButtonTooltips } from '../libs/button-tooltips';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements AfterViewInit, OnDestroy { private dispose?:()=>void; ngAfterViewInit():void{this.dispose=installButtonTooltips();} ngOnDestroy():void{this.dispose?.();} }
